import { useRef, type CSSProperties, type InputHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

// The date of an activity: the browser's own date field, typed as dd-mm-jjjj, but without
// its calendar button as a stop of its own. After the date, Tab went to that calendar
// before it reached the time (Camiel, 21-09-2026: "je moet niet tabben na de datum naar de
// agenda"). The calendar is still a click away, on an icon of our own that Tab passes by.

type DateInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "value" | "onChange" | "style" | "className"> & {
  value: string;
  onChange: (value: string) => void;
  /** For the wrapper, which is what takes the width. */
  style?: CSSProperties;
};

export function DateInput({ value, onChange, style, ...rest }: DateInputProps) {
  const { t } = useTranslation();
  const input = useRef<HTMLInputElement>(null);
  return (
    <span className="wl-date-input" style={style}>
      <input {...rest} ref={input} className="wl-input" type="date" value={value} onChange={(e) => onChange(e.target.value)} />
      <button
        type="button"
        className="wl-date-input__picker"
        tabIndex={-1}
        aria-hidden="true"
        title={t("orders.pickDate")}
        disabled={rest.disabled}
        onClick={() => input.current?.showPicker?.()}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M3 10h18M8 2v4M16 2v4" />
        </svg>
      </button>
    </span>
  );
}
